import { RailIcon } from "@/components/icons/Icon";
import type { RouteId } from "@/routing/routes";
import { ROUTE_TITLES } from "@/routing/routes";
import "./SideRail.css";

type RailEntry = { label: string; anchor: string };

type Props = {
  route: RouteId;
  entries: RailEntry[];
  activeAnchor: string | null;
  open: boolean;
  onToggle: () => void;
  onClose: () => void;
  onNavigateAnchor: (anchor: string) => void;
};

export function SideRail({
  route,
  entries,
  activeAnchor,
  open,
  onToggle,
  onClose,
  onNavigateAnchor,
}: Props) {
  return (
    <>
      <button
        type="button"
        className="rail-toggle"
        aria-expanded={open}
        aria-controls="section-nav"
        onClick={onToggle}
      >
        On this page
      </button>

      {/* The rail column itself never paints: it only gives the sticky capsule
          room to travel. All material lives on .rail-capsule. */}
      <aside
        className={["page-rail", open ? "is-open" : ""].join(" ")}
        aria-label="On this page"
      >
        <div className="rail-capsule botanical-glass">
          <p className="rail-kicker">On this page</p>
          <nav
            className="section-nav glass-copy-scrim"
            id="section-nav"
            aria-label={`${ROUTE_TITLES[route]} sections`}
          >
            {entries.map((entry) => {
              const current = activeAnchor === entry.anchor;
              return (
                <a
                  key={entry.anchor}
                  href={`#${entry.anchor}`}
                  className={["rail-link", current ? "is-active" : ""].join(" ")}
                  data-target={entry.anchor}
                  aria-current={current ? "location" : undefined}
                  onClick={(e) => {
                    e.preventDefault();
                    onNavigateAnchor(entry.anchor);
                    onClose();
                  }}
                >
                  <span className="rail-symbol" aria-hidden="true">
                    <RailIcon label={entry.label} size={17} />
                  </span>
                  <span className="rail-label">{entry.label}</span>
                </a>
              );
            })}
          </nav>
        </div>
      </aside>
    </>
  );
}
